const PatientStatusReportFormValues = {
  selectedPatientId: "",
  referringSiteId: "",
  referringSiteName: "",
  startDate: "",
  endDate: "",
  from: "",
  to: "",
  dateType: "",
  checkbox: "",
};

export default PatientStatusReportFormValues;
